<template>
  <div class="grid-container sm:justify-center">
    <div
      class="flex flex-col justify-center gap-4 w-full pt-6 md:pt-14 sm:col-[4_/_-4] md:col-[5_/_-5] xl:col-[4_/_-4]"
    >
      <div class="flex justify-end">
        <Link :href="$route('company.login')">
          <Button class="btn-tonal">¿Ya tienes cuenta?</Button>
        </Link>
      </div>
      <div class="md:mx-12">
        <header>
          <h1 class="pb-2 headline-md md:headline-lg">Crea tu cuenta ahora, ¡gratis!</h1>
          <p class="title-md md:title-lg">
            Lorem ipsum dolor sit, amet consectetur adipisicing elit.
          </p>
        </header>
        <form @submit.prevent="submitRegistrationForm" class="py-3">
          <TextInput
            id="fullname"
            v-model="form.fullname"
            required
            type="text"
            label="Nombre completo"
            icon="person-outline"
            :error="errors.fullname"
          />
          <TextInput
            id="email"
            v-model="form.email"
            required
            type="email"
            label="Correo empresarial"
            icon="email-outline"
            :error="errors.email"
          />
          <TextInput
            id="password"
            v-model="form.password"
            required
            type="password"
            label="Contraseña"
            icon="lock-outline"
            hint="Elige una contraseña segura entre 8 y 16 carácteres"
            :error="errors.password"
          />
          <TextInput
            id="password_confirmation"
            v-model="form.password_confirmation"
            required
            type="password"
            label="Confirmar contraseña"
            icon="lock-check-outline"
            hint="Asegúrate que las contraseñas coincidan"
            :error="errors.password_confirmation"
          />
          <CheckInput
            id="terms_and_conditions_agreement"
            v-model="form.terms_and_conditions_agreement"
            label="He leído y acepto los Términos y Condiciones del Sitio"
            class="pt-3"
            required
            check-left
            :error="errors.terms_and_conditions_agreement"
          />
          <Button type="submit" class="btn-filled block my-4 mx-auto" :isLoading="form.processing">
            Crear mi cuenta
          </Button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue'
import Layout from '@/Layouts/Layout'
import Button from '@/Components/Button'
import TextInput from '@/Components/FormInputText'
import SelectInput from '@/Components/FormSelect'
import CheckInput from '@/Components/FormInputCheck'

export default {
  name: 'SignUpApplicant',
  layout: Layout,
  props: {
    errors: { type: Object },
  },
  components: {
    Link,
    Button,
    TextInput,
    SelectInput,
    CheckInput,
  },
  data() {
    return {
      form: this.$inertia.form({
        fullname: '',
        email: '',
        password: '',
        password_confirmation: '',
        terms_and_conditions_agreement: false,
      }),
    }
  },
  methods: {
    submitRegistrationForm() {
      const swalErrorConfig = {
        title: '¡Lo sentimos! :(\nHa ocurrido un error.',
        text: 'Por favor, revisa los datos e intenta de nuevo',
      }

      this.form
        .transform(data =>
          Object.fromEntries(Object.entries(data).filter(([_, v]) => v != null && v != '')),
        )
        .post(this.$route('company.register.store'), {
          preserveState: true,
          onError: errors => {
            this.$swal.fire(swalErrorConfig)
          },
        })
    },
  },
}
</script>
